import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule as AngularFormsModule, ReactiveFormsModule as AngularReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule as FormValidationsModule } from 'ng2-validation';
import { TextMaskModule } from 'angular2-text-mask';
import { TreeModule } from 'angular-tree-component';
import { FormComponents } from './form.components';
import { FormServices } from './form.services';
import { FormDirectives } from './form.directives';
import { FormPipes } from './form.pipes';
import { FormInterfaces } from './form.interfaces';
import { Plugins } from './plugins/index';
import { PluginsModule } from '../plugins/plugins.module';
import { FileUploadModule } from 'ng2-file-upload';
import { LocalizationModule } from '../localization/localization.module';
import { SupportModule } from '../support/support.module';
import { AuthenticationModule } from '../authentication/authentication.module';
import { DateTimeInputModule } from './elements/components/datetime/datetime-input.module';
import { NumberInputModule } from './elements/components/number/number-input.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
    imports: [
        CommonModule,
        AngularFormsModule,
        AngularReactiveFormsModule,
        NgSelectModule,
        SupportModule,
        AuthenticationModule,
        LocalizationModule,
        TextMaskModule,
        FormValidationsModule,
        TreeModule,
        PluginsModule,
        FileUploadModule,
        DateTimeInputModule.forRoot(),
        NumberInputModule.forRoot(),
        ColorPickerModule,
    ],
    entryComponents: [],
    declarations: [
        FormComponents,
        FormDirectives,
        FormPipes,
        FormInterfaces,
        Plugins
    ],
    exports: [
        FormComponents,
        FormDirectives,
        FormPipes,
        FormInterfaces,
        Plugins,
        AngularFormsModule,
        AngularReactiveFormsModule,
        FileUploadModule,
        DateTimeInputModule,
        NumberInputModule,
    ],
    providers: [
        FormServices
    ]
})
export class FormsModule {

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/forms.module.ts